import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib';
import type { PaddingOption } from '../sanity/studio/constants';
import { SanityImage } from '../sanity/utils/components/sanity-image';
import type { SanityImageProps } from '../sanity/utils/fragments';

export type ModuleWrapperProps = {
  topPadding?: PaddingOption;
  bottomPadding?: PaddingOption;
  colorTheme?: {
    background:
      | {
          type: 'color';
          color: string | null;
        }
      | {
          type: 'image';
          image: SanityImageProps | null;
        }
      | null;
    textColor: string | null;
    borderColor: string | null;
  } | null;
  className?: string;
} & HTMLAttributes<HTMLDivElement>;

export function ModuleWrapper({
  topPadding = 'medium',
  bottomPadding = 'medium',
  colorTheme,
  children,
  className,
  ...props
}: ModuleWrapperProps & { children: ReactNode }) {
  return (
    <div
      style={
        {
          '--background-color':
            colorTheme?.background?.type === 'color'
              ? colorTheme?.background.color
              : undefined,
          '--text-color': colorTheme?.textColor ?? undefined,
          '--border-color': colorTheme?.borderColor ?? undefined,
        } as CSSProperties
      }
      className={cn(
        'relative',
        topPadding === 'small' && 'pt-8 lg:pt-12',
        topPadding === 'medium' && 'pt-16 lg:pt-20',
        topPadding === 'large' && 'pt-24 lg:pt-36',
        !topPadding && 'pt-24',
        topPadding === 'none' && 'pt-0 lg:pt-0',
        bottomPadding === 'small' && 'pb-8 lg:pb-12',
        bottomPadding === 'medium' && 'pb-16 lg:pb-20',
        bottomPadding === 'large' && 'pb-24 lg:pb-36',
        !bottomPadding && 'pb-16 lg:pb-20',
        bottomPadding === 'none' && 'pb-0 lg:pb-0',
        colorTheme?.background?.type === 'color' &&
          'bg-[var(--background-color)]',
        className
      )}
      {...props}
    >
      {colorTheme?.background?.type === 'image' &&
        colorTheme.background.image && (
          <SanityImage
            image={colorTheme.background.image}
            fill
            className="-z-10"
            sizes="100vw"
          />
        )}
      {children}
    </div>
  );
}
